// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { useState } from 'react';
import { useRouter } from 'next/router';

import Tabs from 'presentations/views/components/atoms/Tabs';
import {
  integrationListPath,
  integrationUserListPath,
} from 'presentations/routes/path';

interface Props {
  currentUrl: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const router = useRouter();
  const links: string[] = [integrationListPath(), integrationUserListPath()];

  let initialIndex = 0;
  links.some((link, index) => {
    if (link === props.currentUrl) {
      initialIndex = index;
      return true;
    }
  });
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  const onChangeTab = (event: React.ChangeEvent<{}>, index: number) => {
    setActiveIndex(index);
    const url = links[index];
    router.push(url);
  };

  return (
    <Tabs
      indicatorColor="primary"
      value={activeIndex}
      onChange={onChangeTab}
      tabs={[
        {
          label: t('Connect'),
        },
        {
          label: t('Team Members'),
        },
      ]}
    />
  );
}
